<template>
  <p class="position-li-container" :class="device.isMobile ? 'position-li-container-mobile' : ''">
    <template v-for="item in content">
      <span class="li-text" :key="item.key" v-if="item.type === 'text'">{{ item.text }}</span>
      <div class="li-position-list" :key="item.key" v-if="item.type === 'positionList'">
        <div class="li-left">
          <img :src="require('@/assets/images/books/book2/list-position-icon.png')" alt="">
        </div>
        <div class="li-right">
          <positionText class="li-right-item" v-for="position in item.content" :key="position.key" :content="position"></positionText>
        </div>
      </div>
      <positionText :key="item.key" v-if="item.type === 'position'" :content="item"></positionText>
    </template>
  </p>
</template>

<script>
/*
列表带定位组件
*/
import positionText from "./positionText.vue";

export default {
  name: "listIndex",
  components: {
    positionText,
  },
  props: {
    content: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.position-li-container{
  .li-text{
    font-style: normal;
    font-size: 24rem;
    font-family: Calibri;
    line-height: 40rem;
    color: #333;
    vertical-align: middle;
  }
  .li-position-list{
    display: flex;
    align-items: center;

    .li-left{
      flex: 0 0 62rem;
      margin-right: 20rem;
      
      img{
        width: 62rem;
        height: 80rem;
      }
    }

    .li-right{
      .li-right-item{
        display: block;
      }
    }
  }
}
.position-li-container-mobile{
  .li-text{
    font-size: 28rem;
  }
}
</style>